import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RegisterState {
  email: string | null;
  companyName: string | null;
  currentStep?: number | null;
  success: boolean;
}

const initialState: RegisterState = {
  email: null,
  companyName: null,
  success: false,
};

const registerSlice = createSlice({
  name: 'registerSlice',
  initialState,
  reducers: {
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setCompanyName: (state, action) => {
      state.companyName = action.payload;
    },
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    clearRegisterState: (state, action) => {
      Object.assign(state, { ...initialState });
    },
  },
});

export const { setEmail, setCompanyName, clearRegisterState } = registerSlice.actions;

export default registerSlice.reducer;
